import React, { FC } from 'react';
import { useApplication } from '../../../../../../context/ApplicationContext';

import Schema from '../../../../../../lib/paths/mittelabruf_FULL_Paths.json';
import { Box, Typography } from '@mui/material';
import CreateForm from '../../../../../../components/ui-component/form-component/create-form/CreateForm';
const P = Schema.attributes;

const Abruf: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	return (
		<>
			<Typography variant="h3">Berechnung der Mittelanforderung</Typography>
			<Box sx={{ mt: '1rem' }}>
				<CreateForm
					formStruc={strucAbruf()}
					formValues={application}
					updateFormValuesFunc={setApplicationProperty}
					readOnly={readOnly}
				/>
			</Box>
		</>
	);
};
export default Abruf;

export const strucAbruf = () => {
	return [
		{
			fields: [
				{ ...P.Berechnung_Der_Mittelanf_0071115044_ittel_Gem_Zuwendungsbescheid, format: 'currency', disabled: true },
				P.Berechnung_Der_Mittelanforderung_Teilzahlung,
				{ ...P.Berechnung_Der_Mittelanforderung_Angeforderter_Betrag, format: 'currency' },
			],
			userProps: { direction: 'column', columnToDivide: 2 },
		},
	];
};
